import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=f4168afe"
import script from "./noticeDialog.vue?vue&type=script&lang=js"
export * from "./noticeDialog.vue?vue&type=script&lang=js"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=f4168afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports